module.exports = __webpack_public_path__ + "img/infj.0cfbd3ef.png";